import type { Language, User, UserType } from '../types';
import { getTranslation } from './translations';

export const USER_TYPES: readonly UserType[] = ['regular', 'nutrition_consultant'];

export function normalizeUserType(value: unknown): UserType {
    return value === 'nutrition_consultant' ? 'nutrition_consultant' : 'regular';
}

export function getUserTypeLabel(language: Language | undefined, userType?: UserType): string {
    const t = (key: Parameters<typeof getTranslation>[1]) => getTranslation(language, key);
    return userType === 'nutrition_consultant' ? t('userTypeNutritionConsultant') : t('userTypeRegular');
}

export function isNutritionConsultant(user: Pick<User, 'userType'>): boolean {
    return normalizeUserType(user.userType) === 'nutrition_consultant';
}
